export enum ScheduleType {
    Day = 'Day',
    Month = 'Month',
    Year = 'Year',
}

export enum ScheduleDayType {
    EveryDay = 'EveryDay',
    EveryDaysOfMonth = 'EveryDaysOfMonth',
    SpecificDayOfWeek = 'SpecificDayOfWeek',
    SpecificDayOfMonth = 'SpecificDayOfMonth',
    LastDayOfMonth = 'LastDayOfMonth',
    LastWeekdayOfMonth = 'LastWeekdayOfMonth',
    LastDayOfWeekOfMonth = 'LastDayOfWeekOfMonth',
    LastNDaysBeforeMonthEnd = 'LastNDaysBeforeMonthEnd',
    NearestWeekdayToDay = 'NearestWeekdayToDay',
    DayAndWeekdayOfMonth = 'DayAndWeekdayOfMonth',
}

export enum ScheduleMonthType {
    EveryMonth = 'EveryMonth',
    EveryMonthsStartingIn = 'EveryMonthsStartingIn',
    SpecificMonth = 'SpecificMonth',
    EveryMonthBetween = 'EveryMonthBetween',
}

export enum ScheduleYearType {
    EveryYear = 'EveryYear',
    EveryYearsStartingIn = 'EveryYearsStartingIn',
    SpecificYear = 'SpecificYear',
    EveryYearBetween = 'EveryYearBetween',
}
